import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { Paper, TableFooter, TableHead, TableRow } from '@material-ui/core';
import { Chip } from '@react/components/Chip';
import SearchBar from '@react/components/SearchBar';
export var StyledTableContainer = styled(Paper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  padding: ", "px;\n"], ["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  padding: ", "px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing(1);
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing(1);
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing(2);
});
export var StyledTableHead = styled(TableHead)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  th {\n    font-size: 16px;\n    font-weight: ", ";\n    color: #757575;\n  }\n"], ["\n  th {\n    font-size: 16px;\n    font-weight: ", ";\n    color: #757575;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.fontWeightMedium;
});
export var StyledTableRow = styled(TableRow)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &:hover {\n    background-color: #f0f0f7;\n    cursor: pointer;\n  }\n"], ["\n  &:hover {\n    background-color: #f0f0f7;\n    cursor: pointer;\n  }\n"])));
export var StyledTableFooter = styled(TableFooter)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  td {\n    border-bottom: 0;\n  }\n"], ["\n  td {\n    border-bottom: 0;\n  }\n"])));
export var LoaderWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex: 1;\n  text-align: center;\n  align-items: center;\n"], ["\n  flex: 1;\n  text-align: center;\n  align-items: center;\n"])));
export var StyledChip = styled(Chip)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-right: ", "px;\n"], ["\n  margin-right: ", "px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing(1);
});
export var StyledSearchBar = styled(SearchBar)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: sticky;\n  top: 0;\n"], ["\n  position: sticky;\n  top: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
